<template>
  <div style="padding-left: 1.75rem">
    <div class="col2_head">
      <router-link :to="'/'" class="breadcrumb_home">Acasă /</router-link>
      {{ $route.name }}
      <div class="subHeadTitle">Raport centralizare</div>

      <div
        class="col2_subHead"
        style="margin-top: 1.2rem; display: flex; justify-content: flex-end"
      >
        <div class="Button1 Btn_center" @click="generateExcel">
          <div class="icon">
            <i class="fas fa-download"></i>
          </div>
          <span class="Btn_content"> Descarcă </span>
        </div>
      </div>
    </div>
    <template>
      <template v-if="PERMISIONS.list">
        <table-parent
          :reloadCount="reloadTable"
          :tableHead="tableHead"
          :prepareFn="prepareData"
          :apiModule="tableModule"
          apiModuleName="PAAP_CENTRALIZATION_CPV_REPORT"
          @totalRecords="(x) => (totalRecords = x)"
          @filterQuery="(x) => (currentFilter = x)"
        />
      </template>
      <template v-else>
        <h3 style="display: flex; flex-direction: column; align-items: center">
          <span style="font-size: 4rem">
            <i class="fas fa-exclamation-triangle"></i>
          </span>
          Acces interzis
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
import { saveAs } from "file-saver";
import PermisionsMixin from "../mixins/assignmentProductsPermMixin.js";
import updateRoleStatus from "../mixins/updateUserRoleStatus.js";
import {
  PAAP_CENTRALIZATION_CPV_REPORT,
  PAAP_CENTRALIZATION_CPV_GENERATE,
} from "../api.js";
import TableParent from "@/components/TableParent";

export default {
  mixins: [PermisionsMixin, updateRoleStatus],
  components: {
    TableParent,
  },
  data() {
    return {
      tableHead: [
        {
          title: "Identificator",
          queryKey: "identifier",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Anul paap",
          queryKey: "paapyear",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Diviziune",
          queryKey: "division",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cod diviziune",
          queryKey: "divisionCode",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Grup",
          queryKey: "group",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cod grup",
          queryKey: "groupCode",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Clasa",
          queryKey: "class",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cod clasa",
          queryKey: "classCode",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Categorie",
          queryKey: "category",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cod categorie",
          queryKey: "categoryCode",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Nume CPV",
          queryKey: "name",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Cod CPV",
          queryKey: "cpvCode",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală estimată, fără TVA",
          queryKey: "estimatedTotalValueWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală estimată, cu TVA",
          queryKey: "estimatedTotalValueWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, fără TVA",
          queryKey: "totalWithoutTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
        {
          title: "Valoarea totală, cu TVA",
          queryKey: "totalWithTva",
          bottomHead: {
            quikFiltre: true,
          },
        },
      ],
      tableModule: PAAP_CENTRALIZATION_CPV_REPORT,
      totalRecords: 0,
      reloadTable: 0,
      currentFilter: "",
    };
  },
  methods: {
    reload() {
      this.reloadTable++;
    },
    generateExcel() {
      if (!this.totalRecords) {
        this.$toastr.w("Nu există date!");
        return;
      }
      PAAP_CENTRALIZATION_CPV_GENERATE(this.currentFilter)
        .then((res) => {
          saveAs(res, res.filename);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    prepareData(row) {
      const preparation = [
        row.identifier,
        row.paapyear,
        row.division || "-",
        row.divisionCode || "-",
        row.group || "-",
        row.groupCode || "-",
        row.class || "-",
        row.classCode || "-",
        row.category || "-",
        row.categoryCode || "-",
        row.name || "-",
        row.cpvCode || "-",
        this.prepareLocaleNumber(row.estimatedTotalValueWithoutTva),
        this.prepareLocaleNumber(row.estimatedTotalValueWithTva),
        this.prepareLocaleNumber(row.totalWithoutTva),
        this.prepareLocaleNumber(row.totalWithTva),
      ];

      return preparation;
    },
  },
  created() {
    if (!this.PERMISIONS.list) {
      return;
    }
    this.updateRoleStatus();
  },
};
</script>
<style></style>
